/* Application Identifiers (AIs) are numeric prefixes in the GS1-128 barcode
 * These codes identify the meaning and format of data attributes and are defined by GS1 global standards
 *
 * This const is a mapping of AI meaning to numerical code based on global standards
 * Codes derived from https://www.gs1.org/standards/barcodes-epcrfid-id-keys/gs1-general-specifications
 */
export const AiCode = Object.freeze({
    SerialShippingContainerCode: '00',
    GTIN: '01',
    GTINContainer: '02',
    MTOGTIN: '03',
    BatchLotNumber: '10',
    ProductionDate: '11',
    InvoiceDueDate: '12',
    PackagingDate: '13',
    BestBeforeDate: '15',
    SellByDate: '16',
    ExpirationDate: '17',
    InternalProductVariant: '20',
    SerialNumber: '21',
    ConsumerProductVariant: '22',
    ThirdPartyGTIN: '235',
    AdditionalProductIdentification: '240',
    CustomerPartNumber: '241',
    MadeToOrderVariationNumber: '242',
    PackagingComponentNumber: '243',
    SecondarySerialNumber: '250',
    ReferencetoSourceEntity: '251',
    GlobalDocumentTypeIdentifier: '253',
    GLNExtensionComponent: '254',
    GlobalCouponNumberGCN: '255',
    CountOfItems: '30',
    ProductNetWeightKg: '310',
    ProductLength1stDimensionM: '311',
    ProductWidthDiameter2ndDimensionM: '312',
    ProductDepthThicknessHeight3rdDimensionM: '313',
    ProductAreaSqM: '314',
    ProductNetVolumeL: '315',
    ProductNetVolumeM: '316',
    ProductNetWeightLbs: '320',
    ProductLength1stDimensionIn: '321',
    ProductLength1stDimensionFt: '322',
    ProductLength1stDimensionYd: '323',
    ProductWidthDiameter2ndDimensionIn: '324',
    ProductWidthDiameter2ndDimensionFt: '325',
    ProductWidthDiameter2ndDimensionYd: '326',
    ProductDepthThicknessHeight3rdDimensionIn: '327',
    ProductDepthThicknessHeight3rdDimensionFt: '328',
    ProductDepthThickness3rdDimensionYd: '329',
    ContainerGrossWeightKg: '330',
    ContainerLength1stDimensionM: '331',
    ContainerWidthDiameter2ndDimensionM: '332',
    ContainerDepthThickness3rdDimensionM: '333',
    ContainerAreaSqM: '334',
    ContainerGrossVolumeL: '335',
    ContainerGrossVolumeCubicM: '336',
    ContainerGrossKgPerSqM: '337',
    ContainerGrossWeightLbs: '340',
    ContainerLength1stDimensionIn: '341',
    ContainerLength1stDimensionFt: '342',
    ContainerLength1stDimensionYd: '343',
    ContainerWidthDiameter2ndDimensionIn: '344',
    ContainerWidthDiameter2ndDimensionFt: '345',
    ContainerWidthDiameter2ndDimensionYd: '346',
    ContainerDepthThicknessHeight3rdDimensionIn: '347',
    ContainerDepthThicknessHeight3rdDimensionFt: '348',
    ContainerDepthThicknessHeight3rdDimensionYd: '349',
    ProductAreaSqIn: '350',
    ProductAreaSqFt: '351',
    ProductAreaSqYd: '352',
    ContainerAreaSqIn: '353',
    ContainerAreaSqFt: '354',
    ContainerAreaSqYd: '355',
    NetWeightTroyOz: '356',
    NetWeightVolumeOz: '357',
    ProductVolumeQt: '360',
    ProductVolumeGal: '361',
    ContainerGrossVolumeQt: '362',
    ContainerGrossVolumeUSGal: '363',
    ProductVolumeCubicIn: '364',
    ProductVolumeCubicFt: '365',
    ProductVolumeCubicYd: '366',
    ContainerGrossVolumeCubicIn: '367',
    ContainerGrossVolumeCubicFt: '368',
    ContainerGrossVolumeCubicYd: '369',
    NumberofUnitsContained: '37',
    AmountPayableLocalCurrency: '390',
    AmountPayableISOCurrencyCode: '391',
    AmountPayableSingleItemLocalCurrency: '392',
    AmountPayableSingleItemxWithISOcurrencycode: '393',
    PercentDiscountOfCoupon: '394',
    AmountPayablePerUnitOfMeasure: '395',
    CustomerPurchaseOrderNumber: '400',
    ConsignmentNumber: '401',
    GlobalShipmentId: '402',
    RoutingCode: '403',
    ShipToDeliverToLocationCodeGlobalLocationNumber: '410',
    BillToInvoiceLocationCodeGlobalLocationNumber: '411',
    PurchaseFromLocationCodeGlobalLocationNumber: '412',
    ShipForDeliverForOrForwardToLocationCode: '413',
    IdentificationOfAPhysicAllocation: '414',
    InvoicingPartyGlobalLocationNumber: '415',
    ProductionLocationGlobalLocationNumber: '416',
    PartyGlobalLocationNumber: '417',
    ShipToDeliverToPostalCodeSinglePostalAuthority: '420',
    ShipToDeliverToPostalCodeISOCountryCode: '421',
    CountryOfOrigin: '422',
    CountryOrCountriesOfInitialProcessing: '423',
    CountryOfProcessing: '424',
    CountryOfDisassembly: '425',
    CountryOfFullProcessChain: '426',
    CountrySubdivisionOriginCode: '427',
    ShipToCompanyName: '4300',
    ShipToContactName: '4301',
    ShipToAddressLine1: '4302',
    ShipToAddressLine2: '4303',
    ShipToSuburb: '4304',
    ShipToLocality: '4305',
    ShipToRegion: '4306',
    ShipToCountryCode: '4307',
    ShipToTelephoneNumber: '4308',
    ShipToGeo: '4309',
    ReturnToCompanyName: '4310',
    ReturnToContactName: '4311',
    ReturnToAddressLine1: '4312',
    ReturnToAddressLine2: '4313',
    ReturnToSuburb: '4314',
    ReturnToLocality: '4315',
    ReturnToRegion: '4316',
    ReturnToCountryCode: '4317',
    ReturnToPostalCode: '4318',
    ReturnToTelephoneNumber: '4319',
    ServiceCodeDescription: '4320',
    DangerousGoodsFlag: '4321',
    AuthorityToLeaveFlag: '4322',
    SignatureRequiredFlag: '4323',
    NotBeforeDeliveryDate: '4324',
    NotAfterDeliveryDate: '4325',
    ReleaseDate: '4326',
    MaxTempF: '4330',
    MaxTempC: '4331',
    MinTempF: '4332',
    MinTempC: '4333',
    NATOStockNumberNSN: '7001',
    UNECEMeatCarcassesAndCutsClassification: '7002',
    ExpirationDateAndTime: '7003',
    ActivePotency: '7004',
    CatchArea: '7005',
    FirstFreezeDate: '7006',
    HarvestDate: '7007',
    AquaticSpecies: '7008',
    FishingGearType: '7009',
    ProductionMethod: '7010',
    TestByDate: '7011',
    RefurbishmentLot: '7020',
    FunctionalStatus: '7021',
    RevisionStatus: '7022',
    GlobalIndividualAssetIdentifierOfAssembly: '7023',
    ProcessorApproval: '703',
    UICExtension: '7040',
    UFRGTUnitType: '7041',
    NationalHealthcareReimburseNumGermanyPzn: '710',
    NationalHealthcareReimburseNumFranceCip: '711',
    NationalHealthcareReimburseNumSpainCn: '712',
    NationalHealthcareReimburseNumBrazilDrn: '713',
    NationalHealthcareReimburseNumPortugalAim: '714',
    NationalHealthcareReimburseNumUsaNdc: '715',
    NationalHealthcareReimburseNumItalyAFIA: '716',
    CertificationReferenceNum: '723',
    ProtocolId: '7240',
    AIDCMediaType: '7241',
    VersionControlNumber: '7242',
    DateOfBirth: '7250',
    DateAndTimeOfBirth: '7251',
    BiologicalSex: '7252',
    FamilyName: '7253',
    GivenName: '7254',
    Suffix: '7255',
    FullName: '7256',
    PersonAddr: '7257',
    BirthSequence: '7258',
    BabyOfFamilyName: '7259',
    RollProductsWidthLengthCoreDiameterDirectionSplices: '8001',
    MobilePhoneIdentifier: '8002',
    GlobalReturnableAssetIdentifier: '8003',
    GlobalIndividualAssetIdentifier: '8004',
    PricePerUnitOfMeasure: '8005',
    IdentificationOfTheComponentsOfAnItem: '8006',
    InternationalBankAccountNumber: '8007',
    DatetimeOfProduction: '8008',
    OpticalReadableSensorIndicator: '8009',
    ComponentPartIdentifier: '8010',
    ComponentPartSerialNumber: '8011',
    SoftwareVersion: '8012',
    GlobalModelNumber: '8013',
    HighlyIndividualisedDeviceRegistrationIdentifier: '8014',
    GlobalServiceRelationNumber: '8017',
    GlobalServiceRelationshipNumber: '8018',
    ServiceRelationInstanceNumber: '8019',
    PaymentSlipPreferenceNumber: '8020',
    IdentificationOfPiecesOfTradeItem: '8026',
    DigitalSignature: '8030',
    CouponcodeIDNorthAmerica: '8110',
    LoyaltyPointsOfCoupon: '8111',
    PositiveOfferCouponId: '8112',
    ExtendedPackagingURL: '8200',
    MutuallyAgreedBetweenTradingPartners: '90',
    InternalCompanyCodes91: '91',
    InternalCompanyCodes92: '92',
    InternalCompanyCodes93: '93',
    InternalCompanyCodes94: '94',
    InternalCompanyCodes95: '95',
    InternalCompanyCodes96: '96',
    InternalCompanyCodes97: '97',
    InternalCompanyCodes98: '98',
    InternalCompanyCodes99: '99',
});
